export const SET_SIDEBAR_COLLAPSE = "SET_SIDEBAR_COLLAPSE";

export const setSidebarCollapse = (isCollapsed) => ({
    type: SET_SIDEBAR_COLLAPSE,
    payload: isCollapsed
});